import React from "react"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./FailedPrinter.module.scss"

const FailedPrinter = props => {
  const {
    printerIndex,
    selectedFailedPrinterIndex,
    setSelectedFailedPrinter,
    setSelectedFailedPrinterIndex,
    totalFailedPrints
  } = props

  const [t, i18n] = useTranslation()

  const printers =
    useSelector(state => state.printers)

  const handleSelect = () => {
    const doesExist = !!printers[printerIndex]

    if (!doesExist) return toast.error(t("پرینتری_وجود_ندارد"))

    setSelectedFailedPrinterIndex(printerIndex)

    setSelectedFailedPrinter(
      printers[printerIndex]
    )
  }

  const printerName =
    printers[printerIndex]?.printerName || ""

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      onClick={handleSelect}
      className={clsx(
        classes["card"],
        selectedFailedPrinterIndex === printerIndex && classes["active"]
      )}
    >
      <div className={classes["wrapper"]}>
        <div className={classes["title"]}>
          {printerName}
        </div>

        <div className={classes["row"]}>
          <div className={classes["number"]}>
            {totalFailedPrints}
          </div>

          <div
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            {t("پرینت_انجام_نشده")}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FailedPrinter